export { PaginationDots } from './pagination-dots';
